module.exports = __webpack_public_path__ + "img/9261b0f2a4d7620dac155fd6cc61b347.png";